import React from 'react';
const portfolioImages = [{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/mfHXLqVssBDF4KZ7oPVyFA/1.jpg'
}, {
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/gkD1m3494awvJfP9xgTHvW/2.jpg'
}, {
  id: 3,
  src: 'https://cdn.magicpatterns.com/uploads/7YM5BBYJHSdHQSGH8Wk4YN/3.jpg'
}, {
  id: 4,
  src: 'https://cdn.magicpatterns.com/uploads/8U3DezXzLPL4xNrqnpp64d/4.jpg'
}, {
  id: 5,
  src: 'https://cdn.magicpatterns.com/uploads/4tqaAbXVh2XvopNRRRSvUh/5.jpg'
}, {
  id: 6,
  src: 'https://cdn.magicpatterns.com/uploads/nHbfbM1haQxnh41RExU1vw/6.jpg'
}, {
  id: 7,
  src: 'https://cdn.magicpatterns.com/uploads/7PPv6vhaXpYbo6JNenuR15/7.jpg'
}, {
  id: 8,
  src: 'https://cdn.magicpatterns.com/uploads/kxX4YLuZ7dvQVHj8TTkVdG/8.jpg'
}, {
  id: 9,
  src: 'https://cdn.magicpatterns.com/uploads/o2NaZfTsbDosyZzhZ6ZDjj/9.jpg'
}, {
  id: 10,
  src: 'https://cdn.magicpatterns.com/uploads/d5srYtHmMmEfLuqUJupzi2/10.jpg'
}];
export const Portfolio = () => {
  const marqueeItems = [...portfolioImages, ...portfolioImages];
  return <section id="catalogo" className="relative scroll-mt-40 py-32 overflow-hidden" data-id="element-163">
      {/* FIXED PARALLAX BACKGROUND */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/m2jTv7q499g1nSVJZH5hTR/fondo_2.png)',
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-164" />

      {/* Subtle overlay */}
      <div className="absolute inset-0 bg-brand-lilac/30 backdrop-blur-[2px] z-0" data-id="element-165" />

      <div className="relative z-10" data-id="element-166">
        <div className="text-center mb-16" data-id="element-167">
          <span className="font-sans text-xs tracking-[0.2em] uppercase text-white/80 mb-4 block drop-shadow-md" data-id="element-168">
            Catálogo
          </span>
          <h2 className="font-serif text-5xl md:text-6xl text-white drop-shadow-lg" data-id="element-169">
            Nuestro Trabajo
          </h2>
        </div>

        {/* Marquee Container */}
        <div className="flex w-[200%] md:w-max group" data-id="element-170">
          <div className="flex animate-marquee group-hover:[animation-play-state:paused] gap-6 px-3" data-id="element-171">
            {marqueeItems.map((item, index) => <div key={`${item.id}-${index}`} className="w-64 md:w-80 aspect-[3/4] rounded-3xl flex-shrink-0 relative overflow-hidden shadow-[0_25px_60px_-15px_rgba(0,0,0,0.45)]" data-id="element-172">
                {item.src ? <img src={item.src} alt={`Trabajo ${item.id}`} className="w-full h-full object-cover" data-id="element-173" /> : <div className="w-full h-full glass-panel flex items-center justify-center" data-id="element-174">
                    <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent" data-id="element-175" />
                    <span className="font-serif italic text-5xl text-white/40 mix-blend-overlay" data-id="element-176">
                      {String(item.id).padStart(2, '0')}
                    </span>
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};